import { Link } from 'react-router-dom';
import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';
import ROUTES from 'constants/routes';
import { getImageUrl } from 'helpers';

const FeautersItem = ({ item, id }) => {
    const { preview_title, preview_text, preview_link_text, preview_icon, slug } = item;

    const featureIcon = getImageUrl(preview_icon)

    return (
        <Link to={`${ROUTES.features}/${slug}`} className="features-item">
            <div className="features-item__icon"><img src={featureIcon} alt="" /></div>
            <div className="features-item__body">
                <div className="description2">{preview_title}</div>
                <div className="body2">{preview_text}</div>
            </div>
            <div className="features-item__link">
                {preview_link_text}
                <Arrow />
            </div>
        </Link>
    );
};

export default FeautersItem;
